import React from "react";
import { Form, Select } from "antd";
import type { FormInstance } from "antd";

import { ISelectOption } from "shared/models";
import { Rule } from "antd/es/form";
import { SizeType } from "antd/es/config-provider/SizeContext";
import { FormLabelAlign } from "antd/es/form/interface";

type Props = {
  placeHolder?: string;
  options: ISelectOption[];
  name: string;
  label: React.ReactNode;
  rules?: Rule[];
  testId?: string;
  form: FormInstance;
  size?: SizeType;
  labelAlign?: FormLabelAlign;
  disabled?: boolean;
  onSelect?: (value: string) => Promise<void>;
};

export const SelectBox = ({
  placeHolder = "Select...",
  options,
  name,
  label,
  form,
  rules,
  testId,
  size,
  labelAlign,
  disabled = false,
  onSelect,
}: Props) => (
  <Form.Item
    name={name}
    label={label}
    labelAlign={labelAlign}
    rules={rules}
    data-testid={testId}
  >
    <Select
      defaultValue=''
      placeholder={placeHolder}
      onSelect={
        onSelect
          ? onSelect
          : (value) => {
              form.setFieldValue(name, value);
            }
      }
      size={size}
      disabled={disabled}
    >
      {[{ value: "", label: "Select..." }, ...options].map((opt, idx) => (
        <Select.Option
          key={`${testId}-option-${idx}`}
          value={opt.value}
          data-testid={`${testId}-option-${idx}`}
        >
          {opt.label}
        </Select.Option>
      ))}
    </Select>
  </Form.Item>
);
